import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { Sport } from '../models/sport';
import * as formatDataHelpers from '../helpers/format-browse-data.helpers';
import * as sortingHelpers from '../helpers/sorting.helpers';
import { BrowseFilter } from '../models/filter';
import { BrowseSorting } from '../models/sorting';
import { API_URL_V4 } from 'src/environments/environment.local';
import { ApiHttpResponse } from '@kinomap-dev/ng-ui-lib';
import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';

@Injectable({ providedIn: 'root' })
export class PlaylistApi {
  private readonly playlistUrl = `${API_URL_V4}/playlist`;
  private readonly limit: number = 15;
  private lastSelectedSport: Sport | null = null;
  private lastFilters: BrowseFilter[] = [];
  private lastSorting: BrowseSorting | null = null;
  private params: HttpParams = new HttpParams();
  isLastPageLoaded: boolean = false;

  constructor(private http: HttpClient) {
    this.params = this.params.set('limit', this.limit).set('page', 1);
  }

  getPlaylists$(
    selectedSport: Sport = this.lastSelectedSport,
    filters: BrowseFilter[] = this.lastFilters,
    sorting: BrowseSorting = this.lastSorting,
    nextPage: boolean
  ): Observable<Playlist[]> {
    this.params = this.params
      .set('sport', selectedSport.name)
      .set('sortType', sortingHelpers.getSortTypeParam(sorting));
    this.setFilterParams(filters);

    if (!nextPage) {
      this.params = this.params.set('page', 1);
      this.isLastPageLoaded = false;
    }

    return this.http.get(this.playlistUrl, { params: this.params }).pipe(
      map((res: any) => {
        const currentPage: number = +res.meta.current_page;
        const lastPage: number = +res.meta.last_page;

        if (currentPage === lastPage) {
          this.isLastPageLoaded = true;
        } else {
          this.params = this.params.set('page', currentPage + 1);
        }

        this.lastSelectedSport = { ...selectedSport };
        this.lastFilters = [
          ...filters.map((filter: BrowseFilter) => {
            return { ...filter };
          }),
        ];
        this.lastSorting = { ...sorting };
        return res.data;
      })
    );
  }

  private setFilterParams(filters: BrowseFilter[]): void {
    // to implement later
    return;
  }

  getHomePlaylists$(selectedSport: Sport): Observable<Playlist[]> {
    const params: HttpParams = new HttpParams().set(
      'sport',
      selectedSport.name
    );

    return this.http.get(this.playlistUrl, { params }).pipe(
      map((res: any) => {
        return res.data;
      })
    );
  }
}
